
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
import { UploadFile } from "@/request/common";
import {
  GetKnowledgeList,
  GetKnowledgeDetail,
  DelKnowledge,
  EditKnowledge,
  GetZidian,
} from "@/request/content";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class Name extends mixins(listMixin) {
  private ifShowEdit: any = false;
  private editData: any = {};
  private window: any = window;
  private data: any[] = [];
  private types: any = [];
  private buwei: any = [];
  private H: any = "";
  private forceUpdate() {
    this.$forceUpdate();
  }
  private getType(type: any, key: any) {
    const params: any = {
      data_type: type,
    };
    GetZidian(this, params).then((res: any) => {
      this[key] = res[type];
    });
  }
  private preview(url: any) {
    window.open(url);
  }
  private upload(file: any, key: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    UploadFile(this, form).then((data: any) => {
      this.editData[key] = data.full_file_url;
      this.forceUpdate();
    });
  }
  private openEdit(item?: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {};
    }
    this.ifShowEdit = true;
  }
  private editSure() {
    if (!this.editData["运动名称"]) {
      this.$message.warning("请输入运动名称！");
      return;
    }
    if (!this.editData["类别"]) {
      this.$message.warning("请选择类别！");
      return;
    }
    if (!this.editData["运动部位"]) {
      this.$message.warning("请选择运动部位！");
      return;
    }
    // if (!this.editData["消耗热量"]) {
    //   this.$message.warning("请输入消耗热量！");
    //   return;
    // }
    if (!this.editData["视频时长"]) {
      this.$message.warning("请输入视频时长！");
      return;
    }
    if (!this.editData["动作视频"]) {
      this.$message.warning("请上传动作视频！");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    // const params: any = {
    //   knowledge_base_id: this.editData.knowledge_base_id,
    //   知识库类型: "运动库",
    //   类别: this.editData["类别"],
    //   运动名称: this.editData["运动名称"],
    //   身体部位: this.editData["身体部位"],
    //   演示视频: this.editData["演示视频"],
    //   动作说明: this.editData["动作说明"],
    // };
    if (!this.editData["知识库类型"]) {
      this.editData["知识库类型"] = "运动库";
    }
    EditKnowledge(this, this.editData, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success(this.editData.id ? "编辑" : "新增" + "成功");
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  /**
   * @description 删除
   */
  private deleteOne(item: any, index: any) {
    this.$confirm("确定删除该条记录么？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          knowledge_base_id: item.knowledge_base_id,
        },
      };
      DelKnowledge(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("删除成功");
          if (this.data.length === 1 && this.filters.current_page !== 1) {
            this.filters.current_page--;
          }
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      知识库类型: "运动库",
      类别: this.filters["类别"],
      运动部位: this.filters["部位"],
      运动名称: this.filters.search,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("yundongkuFilter", JSON.stringify(this.filters));
    GetKnowledgeList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.datas.datas;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "更新时间";
    this.filters.sort_value = 1;
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("yundongkuFilter")) {
      this.filters = JSON.parse(localStorage.getItem("yundongkuFilter") as any);
    }
    this.getList();
  }
}
